module.exports = __webpack_public_path__ + "img/zoom.60bef810.png";